export default __webpack_public_path__ + "static/media/logo.07e91d05.png";